<template>
    <Markdown :source="content_safe" />
</template>

<script>
import Markdown from 'vue3-markdown-it';
export default {
    name: "MarkdownText",
    components: {Markdown},

    props: ['content'],

    computed: {
        content_safe(){
            if( this.content ) return this.content;
            return '';
        }
    }

}
</script>

<style lang="scss" scoped>

</style>
